import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import { useAppSelector } from "../../redux";

const width = 1000;
const height = 505;

const fixText = (price) => {
  const amount = price.toString();
  if (amount.length === 2) {
    return `${amount}.00`;
  }
  if (amount.length === 4) {
    return `${amount}0`;
  }
  return amount;
};

// where to place each location
const locationCoords = {
  "4001 - .Z.MAINE": { x: 600, y: 280 },
  "4002 - .Z.NEWHAMPSHIRE": { x: 575, y: 305 },
  "4003 - .Z.VERMONT": { x: 365, y: 255 },
  "4004 - .Z.CONNECTICUT": { x: 350, y: 407 },
  "4005 - .Z.RHODEISLAND": { x: 490, y: 435 },
  "4006 - .Z.SEMASS": { x: 620, y: 385 },
  "4007 - .Z.WCMASS": { x: 360, y: 360 },
  "4008 - .Z.NEMASSBOST": { x: 590, y: 330 },
  "4000 - .H.INTERNAL_HUB": { x: 620, y: 358 },
};
// where to place names of other stuff
const locationTextCoords = {
  location1: { x: 695, y: 50, text: "NB" },
  location2: { x: 510, y: 150, text: "Phase 2" },
  location3: { x: 370, y: 160, text: "Highgate" },
  location4: { x: 350, y: 310, text: "NYISO AC" },
  location5: { x: 350, y: 470, text: "NYISO NNC" },
  location6: { x: 450, y: 460, text: "NYISO CSC" },
};
const PriceMap = ({ scale }) => {
  // load data
  const graphData = useAppSelector((state) => state.price).data;

  const ref = useRef();
  const styles = {
    transform: `scale(${scale})`,
  };

  useEffect(() => {
    if (graphData.length === 0) {
      setTimeout(() => {}, 10000);
      return;
    }

    const svgContainer = d3.select(ref.current);
    svgContainer.selectAll("*").remove();

    const svg = svgContainer
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .attr("viewBox", `0 0 ${width} ${height}`)
      .attr("style", "max-width: 100%; height: auto; font: 10px National2;");

    // import the image
    svg
      .append("image")
      .attr("href", "/img/newEngland.png")
      .attr("width", 1000)
      .attr("height", 400)
      .attr("x", 50)
      .attr("y", 50);

    // put prices at specific locations
    graphData.forEach((d) => {
      const coords = locationCoords[d.location];
      if (coords) {
        svg
          .append("text")
          .attr("x", coords.x)
          .attr("y", coords.y)
          .attr("fill", "black")
          .attr("font-size", "14px")
          .text(`$${fixText(d.price)}`);
      }
    });

    // add location names
    Object.values(locationTextCoords).forEach((loc) => {
      svg
        .append("text")
        .attr("x", loc.x)
        .attr("y", loc.y)
        .attr("fill", "black")
        .attr("font-size", "14px")
        .text(loc.text);
    });
  }, [graphData]);

  return (
    <svg style={styles} ref={ref} width={width} height={height} id="pricemap" />
  );
};
export default PriceMap;
